import React, { useMemo } from "react";
import "./PrivacyPolicy.css";
import { useLocalContext } from "../../context/LocalContext";

const PrivacyPolicy = () => {
  const { webinfo = {} } = useLocalContext();

  const brand = useMemo(
    () => ({
      name: webinfo.name || "Your Brand",
      email: webinfo.email || "hello@example.com",
      phone: webinfo.phone || "+91 80000 00000",
      phonecall: webinfo.phonecall || "+918000000000",
      address: webinfo.address || "Remote-first • Serving clients worldwide",
    }),
    [webinfo]
  );

  const effectiveDate = useMemo(
    () =>
      new Date().toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    []
  );

  return (
    <section className="pp-about">
      <div className="pp-container">
        <header className="pp-header">
          <span className="pp-badge">Privacy Policy</span>
          <h1>Your privacy matters</h1>
          <p className="pp-intro">
            At <strong>{brand.name}</strong>, we take privacy seriously. This policy explains what data we collect, why we use it, and how you stay in control when you use our site or work with us.
          </p>

          <div className="pp-meta">
            <div>
              <span>Company</span>
              <strong>{brand.name}</strong>
            </div>
            <div>
              <span>Last updated</span>
              <strong>{effectiveDate}</strong>
            </div>
          </div>
        </header>

        <article className="pp-content">
          <section>
            <h2>1. Overview</h2>
            <p>
              This Privacy Policy explains how {brand.name} collects, uses, and safeguards
              personal information when you visit our website, contact us, or work with us.
            </p>
          </section>

          <section>
            <h2>2. Information we collect</h2>
            <ul>
              <li>Name, email address, phone number, and business details you submit.</li>
              <li>Technical data such as IP address, browser type, and device information.</li>
              <li>Usage data collected via cookies and analytics tools.</li>
            </ul>
          </section>

          <section>
            <h2>3. How we use your information</h2>
            <ul>
              <li>To respond to inquiries and deliver services.</li>
              <li>To improve our website, offerings, and communication.</li>
              <li>To comply with legal and contractual obligations.</li>
            </ul>
          </section>

          <section>
            <h2>4. Data sharing</h2>
            <p>
              We do not sell personal data. Information may be shared with trusted service
              providers strictly for operational purposes.
            </p>
          </section>

          <section>
            <h2>5. Your rights</h2>
            <p>
              Depending on your location, you may request access, correction, or deletion
              of your personal data, or object to certain processing.
            </p>
          </section>

          <section>
            <h2>6. Contact</h2>
            <ul className="pp-contact">
              <li>
                <strong>Email:</strong>{" "}
                <a href={`mailto:${brand.email}`}>{brand.email}</a>
              </li>
              <li>
                <strong>Phone:</strong>{" "}
                <a href={`tel:${brand.phonecall}`}>{brand.phone}</a>
              </li>
              <li>
                <strong>Address:</strong> {brand.address}
              </li>
            </ul>
          </section>
        </article>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
